export type Portal = 'creator' | 'viewer';

const DEV_STORAGE_KEY = 'dev_portal_override';

export function detectPortal(): Portal {
  const host = window.location.hostname;
  if (host.startsWith('creator.')) return 'creator';

  if (import.meta.env.DEV) {
    const param = new URLSearchParams(window.location.search).get('portal');
    if (param === 'creator') {
      try { localStorage.setItem(DEV_STORAGE_KEY, 'creator'); } catch { /* ignore */ }
      return 'creator';
    }
    try {
      if (localStorage.getItem(DEV_STORAGE_KEY) === 'creator') return 'creator';
    } catch { /* ignore */ }
  }

  return 'viewer';
}

export function clearDevPortalOverride(): void {
  if (import.meta.env.DEV) {
    try { localStorage.removeItem(DEV_STORAGE_KEY); } catch { /* ignore */ }
  }
}

export function getPortalUrl(portal: Portal): string {
  if (import.meta.env.DEV) {
    const base = window.location.origin;
    return portal === 'creator' ? `${base}?portal=creator` : base;
  }
  return portal === 'creator'
    ? 'https://creator.pixelmachha.com'
    : 'https://pixelmachha.com';
}
